export default {
  API_URL: process.env.REACT_APP_API_URL || '',
  BASE_URL: process.env.REACT_APP_BASE_URL || '',
  IMAGE_URL: process.env.REACT_APP_IMAGE_URL || '',
  VIDEO_URL: process.env.REACT_APP_VIDEO_URL || '',
  TOKEN: process.env.REACT_APP_STRAPI_API_KEY || '',
};
